import React, { useState, useEffect } from "react";
// Tutte le chiamate, DELETE compreso, passano dal client api.js (che antepone
// l'indirizzo del backend e allega il token dell'utente). Il DELETE manda l'id
// nel corpo: api.del accetta un corpo facoltativo (api.js, cantiere CLINICS C2).
import { api } from "../api/api";
import "./ManageModalQPSC.css";

export default function ManageCategoriesModal({ isOpen, onClose, onChanged }) {
  const [categories, setCategories] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editCategory, setEditCategory] = useState(null);
  const [newCategory, setNewCategory] = useState({ name: "", description: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (isOpen) loadCategories();
  }, [isOpen]);

  const loadCategories = async () => {
    const data = await api.get("/categories");
    setCategories(data || []);
  };

  const handleInput = (target, value) => {
    setNewCategory((prev) => ({ ...prev, [target]: value }));
  };

  const handleAdd = async () => {
    setError("");
    setSuccess("");
    if (!newCategory.name.trim()) {
      setError("Category name required!");
      return;
    }
    // Controllo unicità (case-insensitive)
    if (
      categories.some(
        (cat) =>
          cat.name &&
          cat.name.trim().toLowerCase() === newCategory.name.trim().toLowerCase()
      )
    ) {
      setError("Category name must be unique.");
      return;
    }
    try {
      await api.post("/categories", newCategory);
      setNewCategory({ name: "", description: "" });
      setSuccess("Category added successfully!");
      loadCategories();
      onChanged && onChanged();
      setTimeout(() => setSuccess(""), 2000);
    } catch (e) {
      setError("Error while adding category.");
    }
  };

  const handleEditInput = (target, value) => {
    setEditCategory((prev) => ({ ...prev, [target]: value }));
  };

  const handleEditSave = async (idx) => {
    setError("");
    setSuccess("");
    if (!editCategory.name.trim()) {
      setError("Category name required!");
      return;
    }
    // Controllo unicità su edit, ignora il proprio indice
    if (
      categories.some(
        (cat, i) =>
          i !== idx &&
          cat.name &&
          cat.name.trim().toLowerCase() === editCategory.name.trim().toLowerCase()
      )
    ) {
      setError("Category name must be unique.");
      return;
    }
    try {
      await api.put("/categories", {
        original: categories[idx],
        updated: editCategory,
      });
      setEditingIndex(null);
      setEditCategory(null);
      setSuccess("Category updated!");
      loadCategories();
      onChanged && onChanged();
      setTimeout(() => setSuccess(""), 2000);
    } catch (e) {
      setError("Error while updating category.");
    }
  };

  const handleEdit = (idx) => {
    setEditingIndex(idx);
    setEditCategory({ ...categories[idx] });
    setError("");
    setSuccess("");
  };

  const handleDelete = async (idx) => {
    setError("");
    setSuccess("");
    if (!window.confirm("Delete this category?")) return;
    try {
      await api.del("/categories", { id: categories[idx].id });
      setSuccess("Category deleted.");
      loadCategories();
      onChanged && onChanged();
      setTimeout(() => setSuccess(""), 2000);
    } catch (e) {
      setError("Error while deleting category.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modalqpsc-overlay">
      <div className="modalqpsc-window big">
        <div className="modalqpsc-header">
          <h3>Manage Categories</h3>
          <button className="modalqpsc-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modalqpsc-body modalqpsc-scroll">
          {error && <div className="modalqpsc-error">{error}</div>}
          {success && <div className="modalqpsc-success">{success}</div>}
          <table className="modalqpsc-table">
            <thead>
              <tr>
                <th style={{ minWidth: 150, color: "#d21f25", fontStyle: "italic" }}>Category</th>
                <th style={{ minWidth: 220, color: "#d21f25", fontStyle: "italic" }}>Description</th>
                <th style={{ width: 215, color: "#d21f25", fontStyle: "italic" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((c, i) => (
                <tr key={i}>
                  <td>
                    {editingIndex === i ? (
                      <input
                        type="text"
                        value={editCategory.name}
                        onChange={e => handleEditInput("name", e.target.value)}
                        className="modalqpsc-input"
                        placeholder="Category"
                        style={{ marginBottom: 7 }}
                      />
                    ) : (
                      <div style={{ fontWeight: 600 }}>{c.name}</div>
                    )}
                  </td>
                  <td>
                    {editingIndex === i ? (
                      <textarea
                        value={editCategory.description || ""}
                        onChange={e => handleEditInput("description", e.target.value)}
                        className="modalqpsc-input"
                        rows={2}
                        style={{ minWidth: 210 }}
                        placeholder="Description"
                      />
                    ) : (
                      <div>{c.description}</div>
                    )}
                  </td>
                  <td style={{ display: "flex", gap: 7 }}>
                    {editingIndex === i ? (
                      <>
                        <button className="modalqpsc-btn gold" onClick={() => handleEditSave(i)}>
                          Save
                        </button>
                        <button className="modalqpsc-btn" onClick={() => setEditingIndex(null)}>
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button className="modalqpsc-btn gold" onClick={() => handleEdit(i)}>
                          Edit
                        </button>
                        <button className="modalqpsc-btn red" onClick={() => handleDelete(i)}>
                          Delete
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {/* ADD */}
              <tr>
                <td colSpan={3}>
                  <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
                    <input
                      type="text"
                      value={newCategory.name}
                      onChange={e => handleInput("name", e.target.value)}
                      className="modalqpsc-input"
                      placeholder="Category"
                      style={{ marginBottom: 7, width: "60%" }}
                    />
                    <textarea
                      value={newCategory.description}
                      onChange={e => handleInput("description", e.target.value)}
                      className="modalqpsc-input"
                      rows={2}
                      style={{ minWidth: 210, width: "85%" }}
                      placeholder="Description"
                    />
                  </div>
                </td>
                <td>
                  <button className="modalqpsc-btn" onClick={handleAdd}>
                    Add
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}